<template>
  <div>
    <b-modal id="modal-upload-operation" size="lg" centered :title="$t('workspace.bulk-invite-result')" hide-footer>
      <div v-if="uploadResponse && uploadResponse.success.length > 0">
        <h5 class="text-success">{{ $t("common.success") }}</h5>
        <table class="table">
          <thead>
            <tr>
              <th style="width:300px">{{ $t("thirdparty.text") }}</th>
              <th style="width:300px">{{ $t("receiver-group.text") }}</th>
              <th style="width:300px">{{ $t("country.name") }}</th>
              <th style="width:300px">{{ $t("agreement-type.text") }}</th>
              <th style="width:300px">{{ $t("thirdparty.direction") }}</th>
              <th style="width:300px">{{ $t("thirdparty.software-provider") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in uploadResponse.success" :key="item.id">
              <th>{{ item.name }}</th>
              <td>{{ item.receiverGroup }}</td>
              <td>{{ item.country }}</td>
              <td>{{ item.agreementType }}</td>
              <td>{{ item.direction }}</td>
              <td>{{ item.softwareProvider }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="uploadResponse && uploadResponse.failed.length > 0">
        <h5 class="text-danger mt-4">{{ $t("common.failed") }}</h5>

        <table class="table">
          <thead>
            <tr>
              <th style="width:300px">{{ $t("thirdparty.text") }}</th>
              <th style="width:300px">{{ $t("receiver-group.text") }}</th>
              <th style="width:300px">{{ $t("country.name") }}</th>
              <th style="width:300px">{{ $t("agreement-type.text") }}</th>
              <th style="width:300px">{{ $t("thirdparty.direction") }}</th>
              <th style="width:300px">{{ $t("thirdparty.software-provider") }}</th>
              <th scope="col">{{ $t("alert.error") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in uploadResponse.failed" :key="item.id">
              <th>{{ item.name }}</th>
              <td>{{ item.receiverGroup }}</td>
              <td>{{ item.country }}</td>
              <td>{{ item.agreementType }}</td>
              <td>{{ item.direction }}</td>
              <td>{{ item.softwareProvider }}</td>

              <td style="width: 40%;">
                {{ item.cause }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal id="modal-receiver-group" size="sm" centered :title="$t('receiver-group.plural')" hide-footer>
      <div v-if="receiverGroupPagination && receiverGroupPagination.docs">
        <div v-for="item in receiverGroupPagination.docs" :key="item.id">
          <ul>
            <li>
              {{ item.name | translate }}
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-country" size="sm" centered :title="$t('country.text')" hide-footer>
      <div v-if="countryList">
        <div v-for="item in countryList" :key="item.id">
          <ul>
            <li>
              {{ item.name | translate }}
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-direction" size="sm" centered :title="$t('thirdparty.direction')" hide-footer>
      <ul>
        <li>{{ $t("thirdparty.none") }}</li>
        <li>{{ $t("thirdparty.export") }}</li>
        <li>{{ $t("thirdparty.import") }}</li>
        <li>{{ $t("thirdparty.both") }}</li>
      </ul>
    </b-modal>

    <div class="alert alert-warning">
      <ul>
        <li>
          <p>{{ $t("thirdparty.import-thirdparty.import-template-p1") }}</p>
        </li>
        <li>
          <p v-html="$t('thirdparty.import-thirdparty.import-template-p2')"></p>
        </li>
        <li>
          <p>
            {{ $t("receiver-group.display") }}
            <a href="#" @click="openModal('receiver-group')"> {{ $t("common.click") }}</a>
          </p>
        </li>
        <li>
          <p>
            {{ $t("country.display") }}
            <a href="#" @click="openModal('country')"> {{ $t("common.click") }}</a>
          </p>
        </li>
        <li>
          <p>
            {{ $t("thirdparty.display-direction") }}
            <a href="#" @click="openModal('direction')"> {{ $t("common.click") }}</a>
          </p>
        </li>
      </ul>
    </div>
    <div class="alert alert-info">{{ $t("thirdparty.import-thirdparty.import-template-p3") }}</div>
    <div>
      <table class="table table-bordered">
        <thead>
          <tr style="font-weight: bold;">
            <td>{{ $t("common.name") }}</td>
            <td>{{ $t("receiver-group.text") }}</td>
            <td>{{ $t("country.name") }}</td>
            <td>{{ $t("agreement-type.text") }}</td>
            <td>{{ $t("thirdparty.direction") }}</td>
            <td>{{ $t("thirdparty.software-provider") }}</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t("common.name") }}</td>
            <td>{{ $t("receiver-group.name") }}</td>
            <td>{{ $t("country.name") }}</td>
            <td>{{ $t("agreement-type.name") }}</td>
            <td>{{ $t("thirdparty.direction") }}</td>
            <td>{{ $t("common.yes") }}/{{ $t("common.no") }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="card bg-light">
      <div class="card-body">
        <file-rocket :allowedFormats="allowedFormats" @response="handleUploadResponse" :maxFileSize="5242880" :targetUrl="targetUrl"></file-rocket>
      </div>
    </div>
  </div>
</template>

<script>
import FileRocket from "../../components/common/form/file-rocket.vue";
import Countries from "../countries/countries.json";

export default {
  props: { workspace: { type: Object }, store: { type: String, required: false } },
  components: { FileRocket },
  data() {
    return { countryList: [], uploadResponse: undefined, allowedFormats: ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"] };
  },

  computed: {
    isUpdating() {
      return this.$store.getters["workspace/isUpdating"];
    },
    receiverGroupPagination() {
      return this.$store.getters["receiverGroup/pagination"];
    },

    currentStore() {
      return this.store ? this.store : "organizationThirdparty";
    },
    targetUrl() {
      return `/thirdparty/import`;
    },
  },
  async mounted() {
    this.countryList = Countries;
    await this.paginateReceiverGroup();
  },
  methods: {
    openModal(id) {
      this.$bvModal.show("modal-" + id);
    },
    async paginateReceiverGroup() {
      const response = await this.$store.dispatch(`receiverGroup/paginate`, {
        options: { limit: 200 },
      });
    },
    handleUploadResponse(event) {
      try {
        if (event && event?.status !== 200) {
          this.$handleHttpErrorByStatusCode(event?.error);
        }
        this.$emit("onSent");
        this.uploadResponse = event.data;
        this.$root.$emit("bv::show::modal", "modal-upload-operation");
      } catch (error) {
        this.$toast.warning(this.$t("organization.error"));
      }
    },
    onSelect() {
      this.$forceUpdate();
    },
  },
};
</script>
